module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-visitor-ui": "static-1.26201",
      "ably": "static-2.2",
      "conversations-async-data": "static-2.6629",
      "conversations-error-reporting": "static-1.7910",
      "conversations-internal-pub-sub": "static-1.14990",
      "conversations-internal-schema": "static-1.11615",
      "conversations-message-history": "static-1.10077",
      "conversations-test-sdk": "static-1.9449",
      "conversations-visitor-experience-components": "static-1.19564",
      "head-dlb": "static-1.4130",
      "hs-promise-utils": "static-1.4519",
      "hs-test-utils": "static-1.6980",
      "hubspot-dlb": "static-2.1406",
      "HubStyleTokens": "static-2.10498",
      "I18n": "static-7.1398",
      "jasmine-immutable": "static-1.1941",
      "jasmine-runner": "static-1.5400",
      "quartz": "static-1.5737",
      "react-aria": "static-1.39",
      "react-dlb": "static-1.54",
      "react-transition-group": "static-2.8",
      "redux-thunk": "static-2.43",
      "transmute": "static-2.29",
      "urlinator": "static-1.3515",
      "viral-links-lib": "static-1.5860",
      "visitor-ui-component-library": "static-1.5170",
      "webpack-env": "static-1.54",
      "ably-hubspot-js": "static-2.3540",
      "atom": "static-1.4139",
      "autolinker": "static-3.11",
      "classnames": "static-2.10",
      "conversations-http": "static-1.3780",
      "conversations-infrastructure": "static-1.7909",
      "conversations-prop-types": "static-1.6429",
      "conversations-visibility-tools": "static-1.4753",
      "conversations-visitor-message-history": "static-1.18301",
      "cssUtils": "static-1.527",
      "enviro": "static-4.310",
      "flux-actions": "static-1.278",
      "hs-lodash": "static-4.45",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3063",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "metrics-js": "static-1.8459",
      "PatternValidationJS": "static-1.437",
      "PortalIdParser": "static-2.288",
      "raven": "static-3.4958",
      "react": "static-7.151",
      "react-dom": "static-7.85",
      "react-redux": "static-7.16",
      "react-rhumb": "static-1.15544",
      "react-select-plus": "static-1.65",
      "react-utils": "static-2.4462",
      "redux": "static-4.16",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize": "static-1.3356",
      "sanitize-text": "static-1.7141",
      "signup-constants": "static-1.16625",
      "styled-components": "static-2.64",
      "StyleGuideUI": "static-3.466",
      "usage-tracker": "static-1.6452",
      "usage-tracker-core": "static-1.6302",
      "usage-tracker-multi": "static-1.4866",
      "usage-tracker-public": "static-1.6263",
      "visitor-ui-component-library-icons": "static-1.4981",
      "hs-promise-rejection-tracking": "static-1.4492",
      "raven-hubspot": "static-1.5265",
      "hoist-non-react-statics": "static-3.9",
      "bend-plugin-trellis-migration": "static-1.2597",
      "moment": "static-3.26",
      "quartz-core": "static-1.4956",
      "react-immutable-proptypes": "static-2.8",
      "foundations-assets": "static-1.3887",
      "foundations-components": "static-1.6202",
      "foundations-theming": "static-1.3288",
      "UIComponents": "static-3.7445",
      "conversations-skeleton-state": "static-1.6353",
      "cv-backend-services": "static-1.1234",
      "icons": "static-2.592",
      "immutable-less": "static-1.3534",
      "react-input-autosize": "static-2.17",
      "rpc-client-utils": "static-1.3710",
      "ui-images": "static-2.876",
      "permission-components": "static-1.4351",
      "react-virtualized": "static-2.74",
      "HeadJS": "static-2.583",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.2091",
      "msw": "static-1.39",
      "testing-library": "static-1.121",
      "i18n-data": "static-1.199",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3325",
      "quartz-core-utils": "static-1.2604",
      "signup-ui-url-generator": "static-2.7033",
      "HubStyle": "static-2.10806",
      "sassPrefix": "static-1.132",
      "csstype": "static-1.38",
      "history": "static-4.47",
      "usage-tracker-anonymous": "static-1.4869",
      "copilot-toolkit": "static-1.7164",
      "dispatcher": "static-1.114",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.656",
      "hub-http-shared-msw-handlers": "static-1.7279",
      "hubspotter-http": "static-1.3727",
      "hubspotter-http-shared-msw-handlers": "static-1.7277",
      "mobile-manifest-mixins": "static-1.354",
      "platform-navigation-bootstrap": "static-1.11410",
      "quick-fetch": "static-1.2772",
      "react-router-dom": "static-5.26",
      "ui-fonts": "static-1.332",
      "hs-story-utils": "static-1.8347",
      "bend-plugin-foundations-components": "static-1.2471",
      "floating-ui": "static-1.29",
      "foundations-theming-specialty": "static-1.1005",
      "tanstack-table": "static-1.23",
      "bend-plugin-foundations-theming": "static-1.1771",
      "foundations-theming-base": "static-1.2273",
      "ts-schema": "static-1.3262",
      "chatspot-client-types": "static-1.8886",
      "chatspot-core": "static-1.16503",
      "platform-infra-nav-components": "static-1.6835"
    },
    "depPathPrefixes": {
      "conversations-visitor-ui": "/conversations-visitor-ui/static-1.26201",
      "ably": "/ably/static-2.2",
      "conversations-async-data": "/conversations-async-data/static-2.6629",
      "conversations-error-reporting": "/conversations-error-reporting/static-1.7910",
      "conversations-internal-pub-sub": "/conversations-internal-pub-sub/static-1.14990",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.11615",
      "conversations-message-history": "/conversations-message-history/static-1.10077",
      "conversations-test-sdk": "/conversations-test-sdk/static-1.9449",
      "conversations-visitor-experience-components": "/conversations-visitor-experience-components/static-1.19564",
      "head-dlb": "/head-dlb/static-1.4130",
      "hs-promise-utils": "/hs-promise-utils/static-1.4519",
      "hs-test-utils": "/hs-test-utils/static-1.6980",
      "hubspot-dlb": "/hubspot-dlb/static-2.1406",
      "HubStyleTokens": "/HubStyleTokens/static-2.10498",
      "I18n": "/I18n/static-7.1398",
      "jasmine-immutable": "/jasmine-immutable/static-1.1941",
      "jasmine-runner": "/jasmine-runner/static-1.5400",
      "quartz": "/quartz/static-1.5737",
      "react-aria": "/react-aria/static-1.39",
      "react-dlb": "/react-dlb/static-1.54",
      "react-transition-group": "/react-transition-group/static-2.8",
      "redux-thunk": "/redux-thunk/static-2.43",
      "transmute": "/transmute/static-2.29",
      "urlinator": "/urlinator/static-1.3515",
      "viral-links-lib": "/viral-links-lib/static-1.5860",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5170",
      "webpack-env": "/webpack-env/static-1.54",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3540",
      "atom": "/atom/static-1.4139",
      "autolinker": "/autolinker/static-3.11",
      "classnames": "/classnames/static-2.10",
      "conversations-http": "/conversations-http/static-1.3780",
      "conversations-infrastructure": "/conversations-infrastructure/static-1.7909",
      "conversations-prop-types": "/conversations-prop-types/static-1.6429",
      "conversations-visibility-tools": "/conversations-visibility-tools/static-1.4753",
      "conversations-visitor-message-history": "/conversations-visitor-message-history/static-1.18301",
      "cssUtils": "/cssUtils/static-1.527",
      "enviro": "/enviro/static-4.310",
      "flux-actions": "/flux-actions/static-1.278",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3063",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "metrics-js": "/metrics-js/static-1.8459",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "PortalIdParser": "/PortalIdParser/static-2.288",
      "raven": "/raven/static-3.4958",
      "react": "/react/static-7.151",
      "react-dom": "/react-dom/static-7.85",
      "react-redux": "/react-redux/static-7.16",
      "react-rhumb": "/react-rhumb/static-1.15544",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-utils": "/react-utils/static-2.4462",
      "redux": "/redux/static-4.16",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize": "/sanitize/static-1.3356",
      "sanitize-text": "/sanitize-text/static-1.7141",
      "signup-constants": "/signup-constants/static-1.16625",
      "styled-components": "/styled-components/static-2.64",
      "StyleGuideUI": "/StyleGuideUI/static-3.466",
      "usage-tracker": "/usage-tracker/static-1.6452",
      "usage-tracker-core": "/usage-tracker-core/static-1.6302",
      "usage-tracker-multi": "/usage-tracker-multi/static-1.4866",
      "usage-tracker-public": "/usage-tracker-public/static-1.6263",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.4981",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4492",
      "raven-hubspot": "/raven-hubspot/static-1.5265",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2597",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4956",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "foundations-assets": "/foundations-assets/static-1.3887",
      "foundations-components": "/foundations-components/static-1.6202",
      "foundations-theming": "/foundations-theming/static-1.3288",
      "UIComponents": "/UIComponents/static-3.7445",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6353",
      "cv-backend-services": "/cv-backend-services/static-1.1234",
      "icons": "/icons/static-2.592",
      "immutable-less": "/immutable-less/static-1.3534",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "rpc-client-utils": "/rpc-client-utils/static-1.3710",
      "ui-images": "/ui-images/static-2.876",
      "permission-components": "/permission-components/static-1.4351",
      "react-virtualized": "/react-virtualized/static-2.74",
      "HeadJS": "/HeadJS/static-2.583",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2091",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.121",
      "i18n-data": "/i18n-data/static-1.199",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3325",
      "quartz-core-utils": "/quartz-core-utils/static-1.2604",
      "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7033",
      "HubStyle": "/HubStyle/static-2.10806",
      "sassPrefix": "/sassPrefix/static-1.132",
      "csstype": "/csstype/static-1.38",
      "history": "/history/static-4.47",
      "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.4869",
      "copilot-toolkit": "/copilot-toolkit/static-1.7164",
      "dispatcher": "/dispatcher/static-1.114",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.656",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7279",
      "hubspotter-http": "/hubspotter-http/static-1.3727",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7277",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.354",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11410",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "react-router-dom": "/react-router-dom/static-5.26",
      "ui-fonts": "/ui-fonts/static-1.332",
      "hs-story-utils": "/hs-story-utils/static-1.8347",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2471",
      "floating-ui": "/floating-ui/static-1.29",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1005",
      "tanstack-table": "/tanstack-table/static-1.23",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1771",
      "foundations-theming-base": "/foundations-theming-base/static-1.2273",
      "ts-schema": "/ts-schema/static-1.3262",
      "chatspot-client-types": "/chatspot-client-types/static-1.8886",
      "chatspot-core": "/chatspot-core/static-1.16503",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6835"
    },
    "project": "conversations-visitor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};